// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3S_R3","open":"open___1-KVm","cell":"cell___3w2Ch","logo":"logo___1KB2V","name":"name___1HEII"};